// extracted by css-extract-rspack-plugin
export default {"compact":"compact--V6gfgN4iinA_EMmi","compactPreview":"compact-preview--YS5N_jL6KcseKu0S","compactPreviewContainer":"compact-preview-container--e4BMZMwyf0D72oVL"};